import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// Initial state
const state = {
  userGuides: [],
  userGuide: {},
  totalPages: 0,
  action: '', // Added to resolve undefined state property issue
};

// Getters
const getters = {
  userGuide: (state) => state.userGuide,
  userGuides: (state) => state.userGuides,
  totalPages: (state) => state.totalPages,
};

// Mutations
const mutations = {
  SET_USER_GUIDE(state, userGuide) {
    state.userGuide = userGuide;
  },

  SET_USER_GUIDES(state, userGuides) {
    state.userGuides = userGuides;
  },

  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
};

// Actions
const actions = {
  async getAllUserGuide({ commit }, [page, search]) {
    if(hasPermission('user_guide')){
      const permission = {
        headers: {
          'X-Permission': 'user_guide',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(
            `/admin/user-guide?page=${page}&product_id=${productId}&search=${search}`,
            permission
        );
        const res = response.data;
        const totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_USER_GUIDES', res.data);
      } catch (error) {
        console.error('Error fetching user guides:', error);
      }
    }
  },

  async create({}, post) {
    const formData = new FormData();
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('caption', post.caption);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    formData.append('short_description', post.short_description  || '');
    if(hasPermission('user_guide')){
      const permission = {
        headers: {
          'X-Permission': 'user_guide',
        },
      };

      try {
        const response = await axios.post(
            `/admin/user-guide/create?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response.data;
      } catch (error) {
        console.error('Error creating user guide:', error);
      }
    }
  },

  async update({}, post) {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('id', post.id);
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('short_description', post.short_description || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    if (post.caption !== undefined) {
      formData.append('caption', post.caption);
    }
    if(hasPermission('user_guide')){
      const permission = {
        headers: {
          'X-Permission': 'user_guide',
        },
      };

      try {
        const response = await axios.post(
            `/admin/user-guide/update/${post.slug}?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response;
      } catch (error) {
        console.error('Error updating user guide:', error);
      }
    }
  },

  async view({ commit }, slug) {
    if(hasPermission('user_guide')){
      const permission = {
        headers: {
          'X-Permission': 'user_guide',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(`/admin/user-guide/${slug}/${productId}`, permission);
        commit('SET_USER_GUIDE', response.data.data);
      } catch (error) {
        console.error('Error fetching user guide:', error);
      }
    }
  },

  async delete({}, userguide) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(`/admin/user-guide/delete/${userguide.slug}/${productId}`, {
        '_method': 'DELETE',
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting user guide:', error);
    }
  },

  async publishing({ commit }, payload) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(
        `/admin/user-guide/publish/${payload.userguide.slug}/${payload.action}?product_id=${productId}`
      );
      switch (payload.action) {
        case 'publish':
          payload.userguide.published = 1;
          payload.userguide.published_at = 'Just now';
          break;
        case 'unpublish':
          payload.userguide.published = 0;
          payload.userguide.published_at = '';
          break;
      }
      commit('SET_USER_GUIDE', payload.userguide);
      return response;
    } catch (error) {
      console.error('Error publishing user guide:', error);
    }
  },
};

// Exporting the Vuex module
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
